<template>
  <div>
    <Form :model="searchCondition" :label-width="100" inline>
      <div>
        <FormItem label="作业名称">
          <Input
            v-model="searchCondition.homework_name"
            placeholder="请输入作业名称关键字"
            style="width:200px;"
            clearable
            @keydown.native.prevent.enter="search(1)"
          ></Input>
        </FormItem>
        <FormItem label="发布者">
          <Input
            v-model="searchCondition.teacher_name"
            placeholder="请输入发布者关键字"
            style="width:200px;"
            clearable
            @keydown.native.prevent.enter="search(1)"
          ></Input>
        </FormItem>
        <FormItem label="所属课程/课时">
          <Input
            v-model="searchCondition.course_title"
            placeholder="请输入所属课程/课时关键字"
            style="width:200px;"
            clearable
            @keydown.native.prevent.enter="search(1)"
          ></Input>
        </FormItem>
      </div>
      <FormItem label="作业状态">
        <Select v-model="searchCondition.status" style="width:200px;" clearable>
          <Option v-for="item in statusOptions" :value="item.key" :key="item.key">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <Form-item label="截止时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px;"
          @on-change="onDateRange"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Date-picker>
      </Form-item>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="`/api/homework/management/list`"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="c1">
          <span v-if="row.objective_sum" style="margin-right:10px;">客观题{{row.objective_sum}}</span>
          <span v-if="row.subjective_sum">主观题{{row.subjective_sum}}</span>
        </template>
        <template slot-scope="{row}" slot="c2">{{row.score}}分</template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              v-if="row.status==1||row.status==3"
              :to="{name:'HomeworkStatis', query:{ hw_id : row.hw_id }}"
            >作业统计</Button>
            <span v-if="row.status==1||row.status==3">-</span>
            <Button type="text" size="small" :to="{name:'HomeworkPreview', query:{id:row.hw_id}}">预览</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { HomeworkStatus } from "@/utils/enums";
export default {
  name: "Homework",
  data() {
    return {
      searchCondition: {
        homework_name: "",
        teacher_name: "",
        course_title: "",
        status: "",
        start_time: "",
        end_time: ""
      },
      statusOptions: HomeworkStatus.getOptions(),
      tableColumns: [
        { title: "作业名称", key: "homework_name", minWidth: 180 },
        { title: "所属课程/课时", key: "course_periods_title", minWidth: 180 },
        { title: "发布者", key: "publisher", minWidth: 100 },
        {
          title: "题目总数",
          slot: "c1",
          minWidth: 120,
          align: "center"
        },
        {
          title: "总分",
          slot: "c2",
          minWidth: 120,
          align: "center"
        },
        { title: "状态", key: "status_name", minWidth: 100, align: "center" },
        {
          title: "提交截止时间",
          key: "end_time_str",
          minWidth: 140,
          align: "center"
        },
        {
          title: "更新时间",
          key: "updated_at_str",
          minWidth: 140,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          minWidth: 140,
          align: "center"
        }
      ]
    };
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.status_name = HomeworkStatus.getValue(item.status) || "草稿";
        item.updated_at_str = new Date(parseInt(item.updated_at) * 1000).format(
          "yyyy-MM-dd hh:mm"
        );
        item.end_time_str = new Date(parseInt(item.end_time) * 1000).format(
          "yyyy-MM-dd hh:mm"
        );
        item.publisher = item.teacher_name || item.assistant_teacher_name;

        let list = [];
        if (item.title) {
          list.push(item.title);
        }
        if (item.periods_title) {
          list.push(item.periods_title);
        }
        item.course_periods_title = list.join("/");
      });
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.homework_name = "";
        this.searchCondition.teacher_name = "";
        this.searchCondition.course_title = "";
        this.searchCondition.status = "";
        this.searchCondition.start_time = "";
        this.searchCondition.end_time = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onDateRange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    }
  }
};
</script>
